module.exports = __webpack_public_path__ + "img/2025-02-13a_2.93894fcb.jpg";